import {API_URL} from '../api/endpoints';

import toastr from 'toastr';

export function setupAxios(axios: any, lang: string) {
    axios.defaults.headers.Accept = 'application/json'
    axios.defaults.withCredentials = true
    axios.interceptors.request.use(
      (config) => {
        return config
      },
      (err: any) => Promise.reject(err)
    )
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.message === "canceled") {
          console.log('Fetch aborted');
        } else if (error.response) {
          const { status, config, data } = error.response;
          const message = data.message ? data.message.toLowerCase() : '';
          const requestPath = config.url;
          const originalRequest = { ...error.config };
          if (status == 400 && !requestPath.includes('/auth') && !requestPath.includes('/api-access-requests')) {
            toastr.error(lang == 'en' ? "The request may violate our usage policies." : "قد تنتهك الطلب سياسات الاستخدام الخاصة بنا.");
          } else if (status === 401 && !requestPath.includes('/auth')) {
            if( message.includes('missing') || (message.includes('expired') && message.includes('access')) && !originalRequest._retry ){
              try {
                originalRequest._retry = true;
                await axios.post(`${API_URL}/auth/refresh`);
                return axios(originalRequest);
              } catch (refreshError) {
                if (window.location.pathname === '/') {
                  window.location.hash = '#expired';
                  return Promise.resolve();
                } else {
                  window.location.href = '/a/sign-in#expired';
                }
              }
            }else if( message.includes('expired') ){
              window.location.href = '/a/sign-in#expired';
            }else if (message.includes('revoked')){
              window.location.href = '/a/sign-in#revoked';
            }
          } else if (status === 403 && !requestPath.includes('/auth') ) {
            if( requestPath.includes('/admin') ){
              window.location.href = '/';
            }else if( message.includes('not enabled')){
              toastr.error(lang == 'en' ? 'The request cannot be processed because this feature is currently disabled. Please refresh your browse.': 'لا يمكن معالجة الطلب لأن هذه الميزة غير مفعّلة حاليًا. يرجى إعادة تحميل الصفحة.');
            }else{
              toastr.error(lang == 'en' ? 'The request cannot be processed because the content is forbidden': 'لا يمكن معالجة الطلب لأن المحتوى محظور');
            }
          } else if (status === 413 ){
            toastr.error(lang == 'en' ? 'The request cannot be processed because the content is too large.': 'لا يمكن معالجة الطلب لأن المحتوى كبير جدًا.');
          } else if (status == 423) {
            toastr.error(lang == 'en' ? "You've exceeded the safety limit, and your account is blocked for 24 hours." : "لقد تجاوزت حد الأمان، وتم حظر حسابك لمدة 24 ساعة.");
          } else if (status == 429 && !requestPath.includes('/auth') && !requestPath.includes('/api-access-requests')) {
            toastr.info(lang == 'en' ? "The requested service is temporarily unavailable due to high demand. Please try again later." : "الخدمة المطلوبة غير متوفرة مؤقتًا بسبب الطلب العالي. يرجى المحاولة مرة أخرى في وقت لاحق.");
          } else if (status === 500) {
            toastr.error(lang == 'en' ? 'Something went wrong. Please try again later.' : 'حدث خطأ ما. يرجى المحاولة مرة أخرى في وقت لاحق.');
          } else if (status == 503) {
            toastr.info(lang == 'en' ? "Currently the service is not available" : "حاليًا الخدمة غير متوفرة");
          }
        } else {
          toastr.error(lang == 'en' ? 'Network error or no response' : 'خطأ في الشبكة أو عدم الرد');
        }
        return Promise.reject(error);
      }
    )
  }
  